import { render, staticRenderFns } from "./Unknown.vue?vue&type=template&id=31b23688&"
import script from "./Unknown.vue?vue&type=script&lang=ts&"
export * from "./Unknown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports